import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Badge from "./Badge";
import Translate, { translate } from './Translate';
import Icon from './Icon';

const Button = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
    opacity: ${p => p.disabled ? 0.5 : 1};
`;

Button.defaultProps = {
    display: "flex",
    flex: ["1 0 40%", "0 1 auto"],
    alignItems: "center",
    justifyContent: "center",
    paddingX: "md",
    paddingY: "sm",
    margin: "0 0 0 10px",
    height: "40px",
    minHeight: "40px",
    fontSize: "inherit",
    fontFamily: "heading",
    fontWeight: "medium",
    textTransform: "uppercase",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "solid",
    borderRadius: "sm",
    boxShadow: "sm",
    textAlign: "center",
    color: "body",
    bgColor: "gray100",
    selected: {
        color: "white",
        bgColor: "primary",
    }
};

const StarIcon = styled<any, any>(Icon)``;

StarIcon.defaultProps = {
    height: "1.6em",
    width: "1.6em",
    margin: "0 0.25em 0 0"
};

const ButtonText = styled<any, any>('span')`
    ${propStyles};
`;

ButtonText.defaultProps = {
    display: ["none", "inline"]
};

const WatchListBadge = styled(Badge)``;

WatchListBadge.defaultProps = {
    marginX: "sm",
    color: "white",
    bgColor: "gray500",
    selected: {
        color: "primary",
        bgColor: "white"
    }
};

export const WatchListButton: React.SFC<any> = ({ theme, translations, count, active, onClick, ...props }) => (
    <Button
        title={translate(translations, 'Toggle Watch List')}
        onClick={onClick}
        data-selected={active}
        disabled={count === 0}
        {...props}
        {...theme.WatchListButton}
    >
        {
            active ? <StarIcon fileName="WatchlistButtonIcon" /> : <StarIcon fileName="WatchlistButtonOutlineIcon" />
        }
        <ButtonText>
            <Translate>Watch List</Translate>
        </ButtonText>
        <WatchListBadge
            data-selected={active}
            {...theme.WatchListBadge}
        >
            {count}
        </WatchListBadge>
    </Button>
);

export default inject('translations')(observer(withTheme(WatchListButton))) as any;


// WEBPACK FOOTER //
// ./src/Components/WatchListButton.tsx